import React, { useState } from 'react';
import { Offcanvas, Nav } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './SideBar.css'; // Import the custom CSS file

import SideMenu from './SideMenu';

const SideBar = () => {
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [isMobileOpen, setIsMobileOpen] = useState(false); // State for mobile sidebar visibility
  
    // Toggle sidebar for desktop
    const toggleSidebar = () => {
        setIsCollapsed(!isCollapsed);
    };

    // Toggle sidebar for mobile
    const toggleMobileSidebar = () => {
        setIsMobileOpen(!isMobileOpen);
    };

    return (
        <>
            {/* Mobile Toggle Button */}
            <button
                className="btn sidebar-toggle d-lg-none"
                onClick={toggleMobileSidebar}
            >
                {isMobileOpen ? '⬅️' : '➡️'}
            </button>

            {/* Sidebar for Desktop */}
            <div className={`sidebar d-none d-lg-flex flex-column ${isCollapsed ? 'collapsed' : ''}`}>
                <Nav className="flex-column p-2">
                    <SideMenu mobile={false}  isCollapsed={isCollapsed}/>
                </Nav>
                <button
                    className="btn sidebar-collapse-btn text-end mb-auto"
                    onClick={toggleSidebar}
                >
                    {isCollapsed ? '➡️' : '⬅️'}
                </button>
            </div>

            {/* Sidebar for Mobile */}
            <Offcanvas
                show={isMobileOpen}
                onHide={toggleMobileSidebar}
                className="sidebar-mobile"
            >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Menu</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <Nav className="flex-column">
                        <SideMenu mobile={true} isCollapsed={isCollapsed} />
                    </Nav>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
};

export default SideBar;